module.exports = "/images/vendor/flag-icon-css/flags/4x3/ba.svg?3223166179b08490c6c2291ace1894f0";